import { createContext } from 'react';
import { IApi } from '~contexts/api/api.models';

export const ApiContext = createContext<IApi[]>([]);

export default ApiContext;